<template>
    <div class="application-list-container">
        <h4>{{ category }}</h4>
        <div class="list-wrapper">
            <a
                class="item"
                v-for="item in list"
                :href="item.detail.link"
                :key="item.id"
            >
                <div class="name">{{ item.detail.name }}</div>
            </a>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import { getDataRows, getDataHierarchy } from '@custouch/proxy-use'
const {CMS}=window.env

export default {
    name: 'applicationFieldList',
    props: ['hId'],
    data() {
        return {
            list: [],
            category: ''
        }
    },
    async created() {
        const [{ name }, { data }] = await Promise.all([
            getDataHierarchy({ dataHierarchyId: this.hId }),
            getDataRows({
                dataHierarchyId: this.hId,
                dataTemplateId: CMS.template.applicationField,
                index: 1,
                size: 99
            })
        ])
        this.category = name
        this.list = data
        this.$nextTick(() => {
            anime({
                targets: '.application-list-container .item',
                opacity: [0, 1],
                translateY: ['200%', 0],
                duration: 750,
                easing: 'spring(1, 80, 10, 0)',
                delay: anime.stagger(100)
            })
        })
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/style/mixin.less';
.application-list-container {
    padding: 1rem;
}
.list-wrapper {
    .item {
        opacity: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 2.2rem;
        border-bottom: 1px solid #ebebeb;
        &::after {
            content: '';
            position: relative;
            right: 1rem;
            .arrow(@direction: right, @size: 0.4rem, @color: @blue);
        }
    }
}
</style>
